import * as types from './engagement.types'

export const actions = {
  toggleLoading: payload => ({
    type: types.TOGGLE_LOADING,
    payload,
  }),
  toggleSuccess: payload => ({
    type: types.TOGGLE_SUCCESS,
    payload,
  }),
  set: payload => ({
    type: types.SET_ENGAGEMENT,
    payload,
  }),
  create: payload => ({
    type: types.CREATE_ENGAGEMENT,
    payload,
  }),
  get: payload => ({
    type: types.GET_ENGAGEMENT,
    payload,
  }),
  edit: payload => ({
    type: types.EDIT_ENGAGEMENT,
    payload,
  }),
  delete: payload => ({
    type: types.DELETE_ENGAGEMENT,
    payload,
  }),
  setErrors: payload => ({
    type: types.SET_ERRORS,
    payload,
  }),
  getOptions: () => ({
    type: types.GET_OTPIONS,
  }),
  setOptions: payload => ({
    type: types.SET_OPTIONS,
    payload,
  }),
  clearData: payload => ({
    type: types.CLEAR_DATA,
    payload,
  }),
  setPermissions: payload => ({
    type: types.SET_PERMISSIONS,
    payload,
  }),
}
